const styles = {
  tabList: {
    minHeight: 'auto',
    '&.MuiTabs-root': {
      borderRadius: '4px!important',
      backgroundColor: 'background.grey',
    },
    '&.MuiTabs': {
      // padding: '8px !important',
    },
  },
  tab: {
    // padding: '8px!important',
    mb: 2,
    width: '45%',
    borderRadius: '0px!important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'text.primaryDark!important',
    '&.selected': {
      backgroundColor: 'primary.main',
      color: 'common.white',
      borderRadius: '4px!important',
    },
    '&:hover': {
      backgroundColor: 'primary.dark',
      color: '#fff!important',
      borderRadius: '4px!important',
    },
    '&.MuiButtonBase-root': {
      width: '47%',
      borderRadius: '4px!important',
      margin: '8px !important',
      color: 'text.primaryDark',
    },
  },
  tabPanel: {
    // marginTop: 2,
    padding: '0px!important',
    // paddingTop: 5,
    // '&.border': {
    //   border: 1,
    //   borderColor: 'background.border',
    //   borderRadius: 1,
    // },
  },
  timelineRoot: {
    padding: 0,
    marginBottom: 0,
    mt: 4,
  },
  timelineItem: {
    alignItems: 'start',
    ':before': {
      display: 'none',
    },
    '&.withoutBullet': {
      minHeight: '50px',
      '& .MuiTypography-root > .MuiBox-root': {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'row',
        '& .MuiTypography-link-text': {
          width: '100%',
        },
        '& .MuiBox-root:nth-of-type(2)': {
          width: { xs: '100%', sm: 'auto', md: 'auto' },
        },
      },
    },
  },
  timelineDot: { m: 0, backgroundColor: 'secondary.main' },
  timelineContent: {
    p: 0,
    pl: 1,
    mt: -1.5,
  },
  titleIcon: {
    display: 'flex',
    alignItems: 'center',
    color: 'text.grey300',
  },
  ctaButton: {
    display: 'block',
    mt: 1,
    color: 'text.greyDark',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: 'bold',
    ':hover': {
      textDecoration: 'none',
    },
  },
  timelineSeparatorSecondary: { transform: 'rotate(90deg)', height: 40 },

  disclaimerContainer: {
    backgroundColor: 'background.grey450',
    padding: 1,
  },
}
export default styles
